import React from 'react';
import PropTypes from 'prop-types';
import messages from '../registrationMessages';
import FormGroupPart from './FormGroupPart';
import YearSelect from '../../input/YearSelect';

const ReferenceYearPart = ({ value, onChange, disabled, showValidation, inputCols }) => (
  <FormGroupPart
    label={messages.ReferenceYear}
    invalid={showValidation && value !== null && (value < 2000 || value >= 2200)}
    inputCols={inputCols}
  >
    <YearSelect
      id="referenceYearField"
      disabled={disabled}
      value={value}
      onChange={onChange}
      className="form-control input-sm"
      required
    />
  </FormGroupPart>
);
ReferenceYearPart.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  inputCols: PropTypes.string,
  showValidation: PropTypes.bool,
};
ReferenceYearPart.defaultProps = {
  value: 0,
  disabled: false,
  showValidation: false,
  inputCols: 'col-sm-10',
};
export default ReferenceYearPart;
